import React, { createRef } from 'react';
import logo from './logo.svg';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { FirebaseApp, initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, Firestore } from 'firebase/firestore/lite';
import Login from './content/pages/login';
import Home from './content/pages/home';
import UserAccess from './content/pages/userAccess';
import Testimonials from './content/pages/testimonials';
import Puppies from './content/pages/puppies';
import Sires from './content/pages/sires';
import Dames from './content/pages/dames';
import Shows from './content/pages/shows';
import Gallery from './content/pages/gallery';
import Newsletters from './content/pages/newsletters';
import ContactUs from './content/pages/contactus';
import Applications from './content/pages/applications';

const firebaseConfigPublic = {
  apiKey: "AIzaSyDatbxOLgbkHudlDuvjIQQ7--6NOhfH23w",
  authDomain: "starlight-bulldogs.firebaseapp.com",
  projectId: "starlight-bulldogs",
  storageBucket: "starlight-bulldogs.firebasestorage.app",
  messagingSenderId: "853355050149",
  appId: "1:853355050149:web:08578f02b04a55203e094c",
  measurementId: "G-R09RY96H4X"
};

const firebaseConfigAdmin = {
  apiKey: "AIzaSyCNeXhu8s0Pu3zboknjzItR4bRVDpeI6Mo",
  authDomain: "starlight-bulldogs-admin.firebaseapp.com",
  projectId: "starlight-bulldogs-admin",
  storageBucket: "starlight-bulldogs-admin.firebasestorage.app",
  messagingSenderId: "1050785338742",
  appId: "1:1050785338742:web:d78b3c8161384dd756d657"
};


export const db1 = initializeApp(firebaseConfigPublic,'public');
export const db2 = initializeApp(firebaseConfigAdmin,'admin');
export const dbPublic = getFirestore(db1);
export const dbAdmin = getFirestore(db2);
export const user = {username: '', password: '', active: false, id: ''}; 
export const isLoggedIn:any = { value: false };

function App() {
  return (
    <div style={{height: '100%'}}>
    <BrowserRouter>              
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/useraccess" element={<UserAccess />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/puppies" element={<Puppies />} />
        <Route path="/sires" element={<Sires />} />
        <Route path="/dames" element={<Dames />} />
        <Route path="/shows" element={<Shows />} />
        <Route path="/gallery" element={<Gallery />} />

        <Route path="/newsletters" element={<Newsletters />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/applications" element={<Applications />} />
      </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
